import UserView from '../view/UserView';

export default class UserForm extends UserView {
    constructor(json) {
        super(json);

        this.roles = json.roles;
        this.account = json.account;
        this.accountName = json.accountName;
        this.admin = json.admin;
        this.manager = json.manager;
        this.superAdmin = json.superAdmin;
        this.active = json.active;
        this.teams = json.teams ?? null;
    }
}
